<div class="details-menu" #detailsMenu>
  <div class="details-menu-header">
    <span>{{ data.title }}</span>
    <i class="mdi mdi-24px mdi-close" (click)="closeDialog()"></i>
  </div>

  <div class="details-menu-contents">
    <ng-container *ngTemplateOutlet="data.template || sampleTemplate"></ng-container>
  </div>
</div>

<ng-template #sampleTemplate>
  <section>
    <p class="section-title">Sample section title</p>
    <div class="details-menu-row">
      <div class="row-label">Filter:</div>
      <div class="row-value">Sample filter value here</div>
    </div>
    <div class="details-menu-row">
      <div class="row-label">Ip address:</div>
      <div class="row-value">Sample ip address here</div>
    </div>
  </section>
</ng-template>
